module.exports = "data:image/gif;base64,R0lGODlhEAAQAKIAAAAAAP///wD/AACEAMbexqWlpf///wAAACH5BAEAAAYALAAAAAAQABAAAAMtaLrc/jDKRsZUtVwz9B3WFz6dAipAyhQnqAEovIB0ozI1c+Plsjcen2xDNNwSADs="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doc_icons/forapproval.gif
// module id = TEIs
// module chunks = 1